import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function PainAgitation() {
  const painPoints = ['Sientes picazón o ardor y lo primero que haces es buscar en Google', 'Encuentras diez respuestas distintas y terminas más confundida que antes', 'Te automedicas porque "ya sé cómo es esto"', 'El problema mejora unos días y luego vuelve', 'Piensas que quizás estás haciendo algo mal, pero no sabes qué', 'Te da vergüenza preguntar o sientes que ya deberías saber manejar esto'];
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-190">
          ¿Te ha pasado esto?
        </motion.h2>

        <div className="space-y-4 mb-10" data-id="element-191">
          {painPoints.map((point, index) => <motion.div key={index} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-sm" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-192">
              <CheckCircleIcon className="w-6 h-6 text-accent-blush flex-shrink-0 mt-1" data-id="element-193" />
              <p className="text-body text-lg" data-id="element-194">{point}</p>
            </motion.div>)}
        </div>

        <motion.p className="text-center text-xl md:text-2xl font-bold text-heading mb-6" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-195">
          Si marcaste aunque sea una, esta guía fue creada para ti.
        </motion.p>

        <motion.p className="text-body text-lg leading-relaxed max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-196">
          La candidiasis vaginal es una de las afecciones más comunes en
          mujeres, pero también una de las más mal entendidas. No porque sea
          complicada, sino porque nadie nos enseña lo básico. Y esa falta de
          información tiene consecuencias reales: tratamientos incorrectos,
          episodios repetidos, miedo innecesario y decisiones basadas en mitos.
        </motion.p>
      </div>
    </section>;
}